import { Row } from 'ia-react-core';
import styled from 'styled-components';

export const StyledRow = styled(Row)` 
  margin-bottom: 0;
`;
